import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class CommunicationService {
  private headers: HttpHeaders = new HttpHeaders();
  private notificationHeaders: HttpHeaders = new HttpHeaders();
  private multipartHeaders: HttpHeaders = new HttpHeaders();

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    this.notificationHeaders = new HttpHeaders({ 'Content-Type': 'multipart/form-data' });
    this.multipartHeaders = new HttpHeaders({ 'Content-Type': 'multipart/form-data'});
  }

  GetClientActivities(ClientId, ActivityId,Type) {
    return this.http.get<any>('Communication/GetClientActivities?ClientId=' + ClientId + '&ActivityId=' + ActivityId + '&Type=' + Type);
  }

  GetClientActivitiesForDashboard(currentDate) {
    return this.http.get<any>('Communication/GetAllClientActivitiesForDashboard?currentDate=' + currentDate);
  }

    GetUsersForClient(ClientId) {
    return this.http.get<any>('Communication/GetUsersForClient?ClientId=' + ClientId );
  }

  GetClientActivityById(ActivityId) {
    return this.http.get<any>('Communication/GetClientActivityById?ActivityId=' + ActivityId);
  }

  ArchiveClientActivity(ActivityId, Type) {

    return this.http.get<any>('Communication/ArchiveClientActivity?ActivityId=' + ActivityId + '&Type=' + Type);
  }

  MarkActivityCompleted(ActivityId, Type) {
    return this.http.get<any>('Communication/MarkActivityCompleted?ActivityId=' + ActivityId + '&Type=' + Type);
  }

  UpdateActivityStatus(ActivityId, Status,Type) {
    return this.http.get<any>('Communication/UpdateActivityStatus?ActivityId=' + ActivityId + '&Status=' + Status + '&Type=' + Type);
  }

  GetThreadCommunicationById(CommunicationId) {
    return this.http.get<any>('Communication/GetThreadCommunicationById?CommunicationId=' + CommunicationId);
  }

  DeleteCommunicationFile(DocumentId,itemId) {
    return this.http.get<any>('Communication/DeleteCommunicationFile?DocumentId=' + DocumentId + '&ItemId=' + itemId);
  }

  GetAssignedStaffforFilter(jobid, type) {
    return this.http.get<any>('Communication/GetAssignedStaffforFilter?jobid=' + jobid + '&type=' + type);
  }

  DeleteCommunicationComments(Id, type) {
    return this.http.get<any>('Communication/DeleteCommunicationComments?Id=' + Id + '&type=' + type);
  }

  UpdateCommunicationComments(Id, type, comment, tagusers,jobId) {
    return this.http.get<any>('Communication/UpdateCommunicationComments?Id=' + Id + '&type=' + type + '&comment=' + comment +'&tagusers=' + tagusers + '&jobId=' + jobId);
  }

  GetActivitybyId(ActivityId,Type) {
    return this.http.get<any>('Communication/GetActivitybyId?ActivityId=' + ActivityId + '&type=' + Type);
  }

  GetSuggestedContactList(ClientId) {
    return this.http.get<any>('Communication/GetCommunicationUsers?ClientId=' + ClientId);
  }

  GetSuggestedContactUserDetails(ClientId: number) {
    return this.http.get<any>(`Communication/GetSuggestedContactUserDetails?ClientId=${ClientId}`);
  }

  DeleteCommunicationFileDMS(documentId,activityId) {
    return this.http.get<any>('Communication/DeleteCommunicationFileSP?documentId=' + documentId + '&activityId=' + activityId);
  }

  AddEditClientActivities(formData) {
    return this.http.post<any>('Communication/AddEditClientActivities', formData);
  }

  UploadActivityDocument(id, type, clientid, activityType, formData) {
    return this.http.post<any>('Communication/UploadActivityDocument/?ActivityId=' + id + '&Type=' + type + '&ClientId=' + clientid + '&ActivityType=' + activityType, formData, { headers: this.multipartHeaders });
  }

  UploadActivityDocumentById(id, type, formData) {
    return this.http.post<any>('Communication/UploadActivityDocument/?ActivityId=' + id + '&Type=' + type , formData, { headers: this.multipartHeaders });
  }

  AddEditClientCommunication(formData) {
    return this.http.post<any>('Communication/AddEditClientCommunication',formData);
  }

  AddEditComment(methodName, commentModel) {
    return this.http.post<any>('Communication/' + methodName + '', commentModel);
  }

}
